import { API_BASE_URL,ACCESS_TOKEN } from '../constants';

const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    })
    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
    .then(response => 
        response.json().then(json => {
            if(!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
    );
};

const requestUpload = (options) => {
    const headers = new Headers({})
    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
    .then(response => 
        response.json().then(json => {
            if(!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
    );
};

export function getCurrentUser() {
    if(!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }

    return request({
        url: API_BASE_URL + "/user/me",
      //  async: true, 
        method: 'GET'
    });
}

export function login(loginRequest) {
    return request({
        url: API_BASE_URL + "/auth/signin",
        method: 'POST',
        body: JSON.stringify(loginRequest)
    });
}

export function loginsso(loginRequest) {
    return request({
        url: API_BASE_URL + "/auth/signinwithsso",
        method: 'POST',
        body: JSON.stringify(loginRequest)
    });
}

export function signup(signupRequest) {
    return request({
        url: API_BASE_URL + "/auth/signup",
        method: 'POST',
        body: JSON.stringify(signupRequest)
    });
}
export function checkEmailAvailability(email) {
    return request({
        url: API_BASE_URL + "/user/checkEmailAvailability?email=" + email,
        method: 'GET'
    });
}
export function checkUsernameAvailability(username) {
    return request({
        url: API_BASE_URL + "/user/checkUsernameAvailability?username=" + username,
        method: 'GET'
    });
}

export function getSkill(skillId) {
    return request({
        url: API_BASE_URL + "/skill/"+skillId,
       // async:true,
        method: 'GET'
    });
}
export function insertOrUpdateSkill(data) {
    return request({
        url: API_BASE_URL + "/skill",
        method: 'POST',
        body: JSON.stringify(data)
    });
}
export function getAllSkill(userId) {
    return request({
        url: API_BASE_URL + "/skill/user/"+userId,
        method: 'GET'
    });
}
export function deleteSkillById(id) {
    return request({
        url: API_BASE_URL + "/skill/"+id,
        method: 'DELETE'
    });
}

export function getAllPeople(userId) {
    return request({
        url: API_BASE_URL + "/people/user/"+userId,
        method: 'GET'
    });
}
export function getPeople(peopleId) {
    return request({
        url: API_BASE_URL + "/people/"+peopleId,
        method: 'GET'
    });
}

export function deletePeopleById(peopleId) {
    return request({
        url: API_BASE_URL + "/people/"+peopleId,
        method: 'DELETE'
    });
}

export function insertOrUpdatePeople(data) {
    return requestUpload({
        url: API_BASE_URL + "/people",
        method: 'POST',
        body: data
    });
}

export function getAllTimeZones() {
    return request({
        url: API_BASE_URL + "/people/timezones/",
        method: 'GET'
    });
}
export function getAllTeam(userId) {
    return request({
        url: API_BASE_URL + "/team/user/"+userId,
        method: 'GET'
    });
}
export function getTeam(teamId) {
    return request({
        url: API_BASE_URL + "/team/"+teamId,
        method: 'GET'
    });
}

export function deleteTeamById(id) {
    return request({
        url: API_BASE_URL + "/team/"+id,
        method: 'DELETE'
    });
}
export function insertOrUpdateTeam(data) {
    return request({
        url: API_BASE_URL + "/team",
        method: 'POST',
        body: JSON.stringify(data)
    });
}
export function getAllEquipment(userId) {
    return request({
        url: API_BASE_URL + "/equipment/user/"+userId,
        method: 'GET'
    });
}
export function getEquipment(equipmentId) {
    return request({
        url: API_BASE_URL + "/equipment/"+equipmentId,
        method: 'GET'
    });
}
export function deleteEquipmentById(id) {
    return request({
        url: API_BASE_URL + "/equipment/"+id,
        method: 'DELETE'
    });
}
export function insertOrUpdateEquipment(data) {
    return request({
        url: API_BASE_URL + "/equipment",
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export function insertOrUpdateSchedule(data) {
    return request({
        url: API_BASE_URL + "/schedule",
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export function saveAllSchedule(data) {
    return request({
        url: API_BASE_URL + "/schedule/saveall",
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export function getScheduleByType(userId,type) {
    return request({
        url: API_BASE_URL + "/schedule/user/"+userId+"/type/"+type,
        method: 'GET'
    });
}

export function getScheduleById(id) {
    return request({
        url: API_BASE_URL + "/schedule/"+id,
        method: 'GET'
    });
}

export function getFormFieldsByUserId(id) {
    return request({
        url: API_BASE_URL + "/calendar/fields/user/"+id,
        method: 'GET'
    });
}

export function getSettingByUserId(userId) {
    return request({
        url: API_BASE_URL + "/setting/user/"+userId,
        method: 'GET'
    });
}



export function insertOrUpdateSetting(settingRequest) {
     return requestUpload({
        url: API_BASE_URL + "/setting",
        method: 'POST',
        enctype:"multipart/form-data",
        body: settingRequest
    });
}

export function getFetchUrlParams(string) {
        let parsed = {}
        if(string !== '') {
            string = string.substring(string.indexOf('?')+1)
            let p1 = string.split('&')
            p1.map(function(value) {
                let params = value.split('=')
                parsed[params[0]] = decodeURIComponent(params[1])
            });
        }
        return parsed
}


export function getWayPoints(data) {
    return request({
        url: API_BASE_URL + "/google/waypoints",
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export function optimizeWayPoints(data) {
    return request({
        url: API_BASE_URL + "/google/optimize",
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export function getAllScheduleEvent(id) {
    return request({
        url: API_BASE_URL + "/calendar/allschedules/user/"+id,
        method: 'GET'
    });
}

export function getJobViewFormFieldsByUserId(id){
     return request({
        url: API_BASE_URL + "/calendar/jobfields/user/"+id,
        method: 'GET'
    });
}

export function getAllUnScheduleAndScheduleWithDate(date,userId,filter){
     return request({
        url: API_BASE_URL + "/calendar/unscheduleandschedule?date="+date+"&userId="+userId+"&filter="+filter,
        method: 'GET'
       // body: JSON.stringify(data)
    });
}
export function getPeopleBySkills(data) {
    return request({
        url: API_BASE_URL + "/people/getPeopleBySkills",
        method: 'POST',
        body: JSON.stringify(data)
    });
}
export function getEquipmentViewFormFieldsByUserId(id) {
    return request({
        url: API_BASE_URL + "/calendar/equipmentview/fields/user/"+id,
        method: 'GET'
    });
}
export function getTeamViewFormFieldsByUserId(id) {
    return request({
        url: API_BASE_URL + "/calendar/teamview/fields/user/"+id,
        method: 'GET'
    });
}
export function getAllLocation(userId) {
    return request({
        url: API_BASE_URL + "/location/user/"+userId,
        method: 'GET'
    });
}
export function getLocation(equipmentId) {
    return request({
        url: API_BASE_URL + "/location/"+equipmentId,
        method: 'GET'
    });
}
export function deleteLocationById(id) {
    return request({
        url: API_BASE_URL + "/location/"+id,
        method: 'DELETE'
    });
}
export function insertOrUpdateLocation(data) {
    return request({
        url: API_BASE_URL + "/location",
        method: 'POST',
        body: JSON.stringify(data)
    });
}
export function getLocationViewFormFieldsByUserId(id) {
    return request({
        url: API_BASE_URL + "/calendar/locationview/fields/user/"+id,
        method: 'GET'
    });
}

export function editRecurringSchedule(data) {
    return request({
        url: API_BASE_URL + "/schedule/recurring",
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export function deleteRecurringSchedule(id) {
    return request({
        url: API_BASE_URL + "/schedule/deleteall/"+id,
        method: 'GET'
    });
}

